/**
 * CopyInstructionsButton — track:workspace-key-onboarding, decision #48253:
 * every human setup step gets a one-click "Copy instructions for your AI"
 * button. `text` is a plain string (from src/lib/copyInstructions.ts, or
 * inline for a simple step) — this component only handles the click/copy/
 * feedback UI, never constructs the text itself, so it can never be the
 * place a secret leaks into a copied block.
 */
import { useState } from "react";

export function CopyInstructionsButton({
  text,
  label = "Copy instructions for your AI",
}: {
  text: string;
  label?: string;
}) {
  const [copied, setCopied] = useState(false);

  function handleCopy() {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  return (
    <button className="btn sm" onClick={handleCopy}>
      {copied ? "✓ Copied!" : label}
    </button>
  );
}
